import React from 'react';
import { injectIntl } from 'react-intl';
import { withRouter } from "react-router-dom";
import withSnackbar from '../../util/withSnackbar';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import moment from 'moment';
import queryString from 'query-string';
import cognitoAuth from '../../util/Cognito';
import { SNACKBAR_OPTIONS, DATE_FORMAT } from '../../constants/CommonConstants';
import SettingMenu from './SettingMenu';
import ChangePasswordDialog from './ChangePasswordDialog';
import "./Header.css";
import ChangeDateDialog from './ChangeDateDialog';
import { refreshPageDetail } from '../../Common/ChangeHeaderDate'
import limitDate from '../../Common/LimitDate'
import ChangeLanguageDialog from './ChangeLanguageDialog';
import { Breadcrumbs, Link } from '@mui/material'
import VersionInfoDialog from './VersionInfoDialog';

class Header extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedDuration: "week",
            userName: cognitoAuth.getUserName(),
            isOperatorScreen: false,
            showSubMenu: this.props.showSubMenu,
            showRange: this.props.showRange,
            showChangePassword: false,
            showChangeLanguage :false,
            showVersionInfo: false,
            //resetPeriodが定義されている場合のみリセットボタンを表示する
            showResetButton: this.props.resetPeriod,
            beginDate: this.props.beginDate,
            endDate: this.props.endDate,
            showChangeDate:false,
            showThirdHeader: this.props.showThirdHeader ?? false,
            customerUserId: this.props.customerUserId,
            isNotificationHidden :true,
        };
        this.sessionTimeout = this.sessionTimeout.bind(this);
        this.httpError = this.httpError.bind(this);
        this.changeDateDetail = this.changeDateDetail.bind(this);
        this.closeChangeDateDialog = this.closeChangeDateDialog.bind(this);
        if (this.props.resetPeriod !== undefined) {
            this.parentResetPriod = this.props.resetPeriod.bind(this);
        }
        this.ceSignOut = this.ceSignOut.bind(this)
        this.resetPeriod = this.resetPeriod.bind(this);
        this.changeLanguage = this.changeLanguage.bind(this);
    }

    componentDidMount() {
        if (window.location.pathname.indexOf("/ce/operatorTop") !== -1) {
            this.setState({
                userName: queryString.parse(window.location.search).id,
                isOperatorScreen: true,
            });
        }
        if (this.props.location.pathname !== "/") {
            let header = {
                'Authorization': '',
                'Content-Type': 'application/json'
            };
            cognitoAuth.getAuthorizationToken().then((token) => {
                header.Authorization = token;
            }).then(() => {
                const controller = new AbortController();
                fetch(process.env.REACT_APP_CE_ACCOUNT, {
                    method: "GET",
                    headers: header,
                    signal: controller.signal,
                }).then(res => {
                    if (res.ok) {
                        return res.json();
                    }
                }).then(data => {
                    this.setState({
                        isNotificationHidden : data.isNotificationHidden,
                    });
                }).catch((e) => {
                    throw e;
                });
            })
        }
    }

    changeDateHeader(startDate,endDate){
        refreshPageDetail(startDate,endDate,this,'Analysis');
        this.props.getAnalysis();
    }

    changeDateDetail(){
        this.setState({
            showChangeDate: true,
        });
    }

    closeChangeDateDialog() {
        this.setState({
            showChangeDate: false
        });
    }

    changePassword() {
        this.setState({
            showChangePassword: true
        });
    }

    changeLanguage() {
        this.setState({
            showChangeLanguage: true
        });
    }

    versionInfo() {
        this.setState({
            showVersionInfo: true
        });
    }

    resetPeriod() {
        if (this.state.showPeriodRange) {
            document.getElementById("durationWeekly").checked = true; 
        }
        this.parentResetPriod(); 
    }

    ceSignOut() {
        localStorage.removeItem("ceUserId");
        localStorage.removeItem("ceAuthorization");
        cognitoAuth.signOut();
    }

    sessionTimeout() {
        cognitoAuth.sessionTimeOut(this.props);
    }

    httpError(errStatus) {
        if (errStatus === 408) {
            // エラーメッセージ表示
            this.props.openSnackbar(this.props.intl.formatMessage({ id: "http_connection_error" }));
        } else {
            // エラーメッセージ表示
            this.props.openSnackbar(this.props.intl.formatMessage({ id: "http_get_error" }, {status: errStatus}));
            // CEログイン画面に遷移させる
            this.props.history.push({ pathname: '/' });
        }
    } 

    BreadcrumbsLayout = () => {
        const CEPathnames = [
            { pathname: 'top', text: this.props.intl.formatMessage({ id: "ce_customers_list_title" }), path: '/top' },
            { pathname: 'editCustomer', text: this.props.intl.formatMessage({ id: "ce_header_editCustomers" }), path: '/top/editCustomer' },
            { pathname: 'addCustomer', text: this.props.intl.formatMessage({ id: "add_customers_account" }), path: '/top/addCustomer' },
            { pathname: 'editSuggestion', text: this.props.intl.formatMessage({ id: "user_suggestion_list" }), path: '/top/editCustomer/editSuggestion' },
            { pathname: 'requests', text: this.props.intl.formatMessage({ id: "ce_header_link_request" }), path: '/top/requests' },
        ];
        const pathnames = this.props.location.pathname.split('/').slice(2);
        const hideBreadcrumbs = pathnames.some(path => CEPathnames.findIndex(({ pathname }) => path === pathname) < 0);
        const breadcrumbs = hideBreadcrumbs ? [] : pathnames.map((path) => CEPathnames.find(({ pathname }) => path === pathname) ?? "");
        return (
            <div className="breadcrumbs">
                <Breadcrumbs separator={<NavigateNextIcon />} aria-label="breadcrumb">
                    {breadcrumbs.map((breadcrumb) => (
                        <Link
                            underline="hover"
                            component="button"
                            onClick={() => {
                                const pathname = `/ce${breadcrumb.path}`;
                                let state = ''
                                switch (breadcrumb.pathname) {
                                    case 'top':
                                        state = { ceId: cognitoAuth.getUserName() };
                                        break;
                                    case 'editCustomer':
                                        let userId = ''
                                        if(pathnames.indexOf('editSuggestion')){
                                            userId = queryString.parse(this.props.location.search).userId
                                        }
                                        state = {
                                            ceId: cognitoAuth.getUserName(),
                                            userId: userId
                                        };
                                        break;
                                    default:
                                        break;
                                }
                                const history = { pathname, state };
                                this.props.history.push(history);
                            }}
                            aria-current="page"
                        >
                            {breadcrumb.text}
                        </Link>
                    ))}
                </Breadcrumbs>
            </div>
        );
    };

    render() {
        return (
            <div id="ceAnalysis">
                {
                    this.state.showSubMenu ?
                    <div>                      
                        <div id="ceHeader">
                            <div className="left">
                                {this.state.isOperatorScreen ? 
                                <img src="/assets/img/AccurioPro_DashboardUltimate.svg" alt="AccurioProCompass" />
                                :<img src="/assets/img/img_logo_Dashboard.svg" alt="AccurioPro" />}
                            </div>
                            <div className="right">
                                {this.state.isOperatorScreen ? 
                                    <div className="userName">{this.props.intl.formatMessage({ id: "ce_top_operator_user_name" }, { userName: this.state.userName })}</div> : <div>
                                    <div className="userName">{this.props.intl.formatMessage({ id: "header_user_id" })} ： {this.state.userName}</div><div className="userLogout" onClick={() => this.ceSignOut}><a href="/"><img alt="user_logout" src="/assets/img/img_logout.svg"/></a></div>
                                    <div className="settingMenu">
                                    <SettingMenu 
                                        intl={this.props.intl} 
                                        changePassword={this.changePassword.bind(this)} 
                                        changeLanguage={this.changeLanguage.bind(this)}
                                        versionInfo={this.versionInfo.bind(this)}
                                        isNotificationHidden={this.state.isNotificationHidden}
                                    />
                                    </div>
                                    </div>
                                }
                            </div>
                        </div>
                        { this.state.showThirdHeader ? null :
                            <div className="thirdHeader">
                            {this.BreadcrumbsLayout()}
                            {(this.state.beginDate && this.state.showSubMenu) && 
                                <div className="period">{moment(this.props.beginDate).valueOf() < moment(limitDate.limitMinDate).valueOf() ? <div className="icon disabled"><div><img alt="less_than_sign" src="/assets/img/less-than-gray sign.svg"/></div>
                                <span className="text">{this.props.intl.formatMessage({ id: "header_previous" })}</span>
                                </div> : <div className="icon" onClick={this.props.changeToPrevious}><div><img alt="less_than_sign" src="/assets/img/less-than sign.svg"/></div><span className="text">{this.props.intl.formatMessage({ id: "header_previous" })}</span></div>}                                    
                                    { this.state.selectedDuration !== 'daily' ?
                                        <div className='date'  onClick={this.changeDateDetail}>
                                        <span>{moment(this.props.beginDate).format(this.props.intl.formatMessage({ id: "date_format" })) + " ~ " + moment(this.props.endDate).format(this.props.intl.formatMessage({ id: "date_format" }))}</span>
                                        </div>
                                        :
                                        <div  onClick={this.changeDateDetail}>
                                        <span className="date">{moment(this.props.beginDate).format(this.props.intl.formatMessage({ id: "date_format" }))}</span>
                                        </div>
                                    }
                                    {moment(this.props.endDate).valueOf() > moment(limitDate.limitMaxDate).add('1','M').valueOf() ? <div className="icon disabled"><span className="text">{this.props.intl.formatMessage({ id: "header_next" })}</span><div><img alt="greater_than_sign" src="/assets/img/greater-than-gray sign.svg"/></div></div> : <div className="icon" onClick={this.props.changeToNext}><span className="text">{this.props.intl.formatMessage({ id: "header_next" })}</span><div><img alt="greater_than_sign" src="/assets/img/greater-than sign.svg"/></div></div>}                                   
                                    {this.state.showResetButton &&
                                        <div className="reset">
                                            {this.props.isInitDate ?
                                                <div className="reset disabled">
                                                <img alt="reset_gray" src="/assets/img/reset_gray.svg"/>
                                                <span className="text disabled"> {this.props.intl.formatMessage({ id: "header_reset" })}</span>
                                                </div>
                                                :
                                                <div className="reset" onClick={this.resetPeriod}>
                                                <img alt="reset" src="/assets/img/reset.svg"/> 
                                                <span className="text">{this.props.intl.formatMessage({ id: "header_reset" })}</span>
                                                </div>
                                            }
                                        </div>
                                    }
                                </div>
                            }
                        </div>
                        }
                        <ChangePasswordDialog show={this.state.showChangePassword} handleClose={() => {this.setState({showChangePassword: false})}} intl={this.props.intl} callback={this.sessionTimeout} httpError={this.httpError} history={this.props.history} />
                        <ChangeLanguageDialog show={this.state.showChangeLanguage} handleClose={() => {this.setState({showChangeLanguage: false})}} intl={this.props.intl}  httpError={this.httpError} />
                        <VersionInfoDialog show={this.state.showVersionInfo} handleClose={() => {this.setState({showVersionInfo: false})}} intl={this.props.intl} />
                        <ChangeDateDialog 
                        show={this.state.showChangeDate} 
                        handleClose={this.closeChangeDateDialog}  
                        intl={this.props.intl} 
                        fromDate={moment(this.props.beginDate).format(DATE_FORMAT)} 
                        toDate={moment(this.props.endDate).format(DATE_FORMAT)}
                        changeDateHeader={this.props.changeDateHeader}
                        key={this.props.beginDate}
                        />
                    </div>
                    :
                    <div id="ceHeader">
                        <div className="left">
                            <img src="/assets/img/img_logo_Dashboard.svg" alt="AccurioPro" />
                        </div>
                    </div>
                }
            </div>
            
        );
    }
}

export default withSnackbar(withRouter(injectIntl(Header)), SNACKBAR_OPTIONS);